<!--
 * @Description: 查看下属人员数据
 * @Autor: lwq
 * @Date: 2020-08-15 14:12:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 17:33:27
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\ViewDataOfSubordinates\index.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text class="px-7">
        <showDataAccessHeader @add='add'
                              :showAdd='false'
                              :label="$t('label_View_data_of_subordinates')"
                              :readonly='readonly'
                              v-model="dataobj.mrbase_sys_data_strategy_subordinate_is_used" />
        <div v-for="(item,index) in list"
             :key='index'>
          <tree v-model="item.exclude_function_uuids"
                :readonly='readonly'
                maxHeight='800'></tree>
        </div>
      </v-card-text>
      <mrc_ess_submitBtn @success='success'
                         v-if="!readonly"
                         :cancelText="$store.state.uuid?$t('label_cancel'):$t('label_The_previous_step')"
                         @cancel='cancel'>
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  listData,
  getData,
  updateData,
  addData,
  delData,
  updatebasis
} from '@/service/api/data-access-strategy'
import showDataAccessHeader from '../showDataAccessHeader'
import dialogModule from './dialogModule'
import tree from '../tree'
export default {
  components: { showDataAccessHeader, dialogModule, tree },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      skeletonloading: true,
      open: false,
      dataobj: {
        mrbase_sys_data_strategy_subordinate_is_used: '0'
      },
      list: [{ exclude_function_uuids: '' }],
    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  async mounted () {
    if (this.$store.state.uuid) {//修改
      await this.getList()
    }
    else {//新增
    }
  },

  methods: {
    async getList () {
      if (this.$store.state.uuid) {
        this.skeletonloading = true
        const res = await getData({ org_level_uuid: this.$store.state.uuid, date: 'mrbase_sys_data_strategy_subordinate' })
        if (res.code == 200) {
          this.list = res.mrbase_sys_data_strategy_subordinate ? res.mrbase_sys_data_strategy_subordinate : [{ exclude_function_uuids: '' }]
          this.dataobj = res.data ? res.data : {}
          this.dataobj.mrbase_sys_data_strategy_subordinate ? '' : this.dataobj.mrbase_sys_data_strategy_subordinate = '0'
        }
        this.skeletonloading = false
      }
      else {

      }
    },
    add () {
      this.open = true
    },
    async success () {
      if (this.$store.state.uuid) {//修改
        let arr = this.list.map(item => {
          return { ...item, strategy_uuid: this.dataobj.uuid }
        })
        const res = await updateData({
          '~table~': 'mrbase_sys_data_strategy_subordinate',
          "mrbase_sys_data_strategy_subordinate_properties": "002",//是否上级查看所有下级数据权限 策略uuid
          org_level_uuid: this.$store.state.uuid,
          mrbase_sys_data_strategy_subordinate_is_used: this.dataobj.mrbase_sys_data_strategy_subordinate_is_used,
          mrbase_sys_data_strategy_subordinate: arr
        })
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_The_modification_was_successful') })
          await this.getList()
          this.$emit('updateSuccess')
        }
        // else {
        //   this.$Message({ text: this.$t(res.msg), color: 'rgba(0, 0, 0, 0.38) ' })
        // }
      }
      else {//新增
        this.$emit('success')
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getList()
        this.$emit('updateSuccess')
      }
      else {
        this.$emit('cancel')
      }
    }
  },
};
</script>

<style scoped>
</style>
